/**
 * Logo animation.
 */
class Logo {
    /**
     * Construct.
     * @param wrapper {HTMLElement}
     */
    constructor(wrapper) {
        const hoverLogo = {};
        hoverLogo.item = wrapper.querySelector('.animated-logo > :nth-child(1)');
        hoverLogo.player = hoverLogo.item.svgatorPlayer;
        const animationLogo = {};
        animationLogo.item = wrapper.querySelector('.animated-logo > :nth-child(2)');
        animationLogo.player = animationLogo.item.svgatorPlayer;
        const animatedLogoClass = 'animated-logo--is-animated';

        if (!animationLogo.player || !hoverLogo) {
            console.warn('no svgator player ready!');

            return;
        }

        animationLogo.player.set('speed', 2);
        hoverLogo.player.set('speed', 4);

        animationLogo.player.on('end', () => {
            wrapper.classList.remove(animatedLogoClass);
        });

        hoverLogo.item.addEventListener('mouseenter', () => {
            hoverLogo.player.set('direction', 1);
            hoverLogo.player.play();
        });

        hoverLogo.item.addEventListener('mouseleave', () => {
            hoverLogo.player.set('direction', -1);
            hoverLogo.player.play();
        });

        if (window.sessionStorage && !window.sessionStorage.getItem('visited')) {
            wrapper.classList.add(animatedLogoClass);
            animationLogo.item.addEventListener('animationend', e => {
                if (e.animationName === 'logoFadeIn') {
                    animationLogo.player.play();
                }
            });

            window.sessionStorage.setItem('visited', '1');
        } else {
            document.documentElement.classList.add('no-logo-animation');
        }
    }
}

export default Logo;
